// Section Banner Media - Effet Parallaxe
class BannerMediaParallax {
  constructor() {
    this.banners = document.querySelectorAll('.banner-media[data-parallax="true"]');
    this.init();
  }

  init() {
    if (this.banners.length === 0) return;

    // Vérifier si l'utilisateur préfère les animations réduites
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    this.setupParallax();
    this.handleResize();
  }

  setupParallax() {
    this.banners.forEach((banner, index) => {
      const mediaContainer = banner.querySelector('.banner-media__media');
      if (!mediaContainer) return;

      // Si le parallax container existe déjà (rechargement de section), ne pas recréer
      if (mediaContainer.querySelector('.banner-media__parallax-container')) return;

      // Créer un conteneur pour l'effet parallaxe
      const parallaxContainer = document.createElement('div');
      parallaxContainer.classList.add('banner-media__parallax-container');

      // Déplacer tout le contenu de media dans le parallax container
      while (mediaContainer.firstChild) {
        parallaxContainer.appendChild(mediaContainer.firstChild);
      }

      // Insérer le parallax container dans media
      mediaContainer.appendChild(parallaxContainer);

      // Stocker les données nécessaires
      banner.parallaxData = {
        container: parallaxContainer,
        speed: 1.1, // Vitesse de parallaxe (plus c'est bas, plus c'est lent)
        initialized: false
      };
    });

    this.bindScrollEvents();
  }

  bindScrollEvents() {
    let ticking = false;

    const updateParallax = () => {
      this.banners.forEach(banner => {
        if (!banner.parallaxData) return;

        const rect = banner.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        // Vérifier si l'élément est visible
        if (rect.bottom >= 0 && rect.top <= windowHeight) {
          // Calculer la position relative de l'élément par rapport à la viewport
          const elementTop = rect.top;
          const elementHeight = rect.height;
          const scrollProgress = (windowHeight - elementTop) / (windowHeight + elementHeight);

          // Calculer le décalage de parallaxe
          const parallaxOffset = (scrollProgress - 0.5) * 100 * banner.parallaxData.speed;

          // Appliquer la transformation
          banner.parallaxData.container.style.transform = `translateY(${parallaxOffset}px) scale(1.04)`;

          if (!banner.parallaxData.initialized) {
            banner.parallaxData.container.style.transition = 'none';
            banner.parallaxData.initialized = true;
          }
        }
      });

      ticking = false;
    };

    const requestTick = () => {
      if (!ticking) {
        requestAnimationFrame(updateParallax);
        ticking = true;
      }
    };

    // Événements de scroll
    window.addEventListener('scroll', requestTick, { passive: true });

    // Initialiser la position
    updateParallax();
  }

  handleResize() {
    let resizeTimeout;

    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        // Réinitialiser les positions lors du redimensionnement
        this.banners.forEach(banner => {
          if (banner.parallaxData) {
            banner.parallaxData.container.style.transform = 'translateY(0px) scale(1.04)';
          }
        });
      }, 250);
    });
  }
}

// Initialiser quand le DOM est prêt
document.addEventListener('DOMContentLoaded', () => {
  new BannerMediaParallax();
});

// Réinitialiser si la page est chargée via Shopify Section Rendering
document.addEventListener('shopify:section:load', (event) => {
  // Vérifier si la section chargée contient un banner avec parallaxe
  const sectionContainer = event.target;
  if (sectionContainer.querySelector('.banner-media[data-parallax="true"]')) {
    new BannerMediaParallax();
  }
});